export const RW_INTELLIGENCE_FLAGS = [
  'AIScheduling',
  'AITreatmentPlanFollowUp',
  'AIMissingInfoCollection',
  'AIPaymentCollection'
] as const;
